export const TESTIMONIALS = [
  {
    initials: 'OG',
    name: 'Oficina em Gaia',
    role: 'Oficina Multimarca',
    text: 'O que mais valorizamos é a facilidade de utilização. Desde a receção até à gestão das intervenções, tudo ficou mais rápido e eficiente. Hoje conseguimos acompanhar melhor o trabalho da oficina e prestar um serviço mais profissional aos clientes.',
  },
  {
    initials: 'OP',
    name: 'Oficina em Porto',
    role: 'Oficina Multimarca',
    text: 'A gestão da oficina tornou-se muito mais simples. Toda a informação fica centralizada, é fácil de consultar e permite acompanhar cada serviço de forma rápida e organizada.',
  },
  {
    initials: 'OB',
    name: 'Oficina em Braga',
    role: 'Oficina Multimarca',
    text: 'Uma ferramenta completa para oficinas multimarca. Permite gerir processos, consultar informação em segundos e ganhar mais produtividade sem complicar o trabalho da equipa.',
  },
] as const
